import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {isObject, isUndefined} from 'util';
import {from, fromEvent, ReplaySubject, Subject, Subscription, takeUntil, throttleTime} from 'rxjs';
import {UntypedFormGroup} from '@angular/forms';
import {filter, first, map} from 'rxjs/operators';
import {IMessage} from '../../services/websocket';
import {AllService} from '../../services/all.service';
import {Chat, IMessengerConnector, MessageUser} from '../../types/all.type';
import {isMobile, log} from '../../functions';
import {AllMessengersService} from '../../pages/page-start/all-messengers.service';
import {InterfaceService} from '../../services/interface.service';
import {AppService} from '../../services/app.service';
import {DcService} from '../../services/dc.service';


@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactsListComponent implements OnInit, OnDestroy {
  @Input() source: 'contacts' | 'chats' = 'contacts';
  @Input() sort: 'abc' | 'default' | 'chats' = 'abc';
  @Input() search: 'local' | 'query' = 'query';
  @Input() isCheckbox = true;
  @Input() scroll: Element;
  @Input() offsetTop = 5;
  @Input() fixedSearch = true;
  @Input() showServiceToggle = false;
  isMobile = isMobile();
  public showCount = 15;
  q: string;
  arResult: MessageUser[] | Chat[] = [];
  arResultBuffer: any = [];
  public isLoadError = false;
  public isLoaded = false;
  public showSearch = false;
  @Input() Service: IMessengerConnector;
  @Output() onToggleUser = new EventEmitter<any>();
  @Output() onToggleService = new EventEmitter<IMessengerConnector>();
  getAvalibleTimeout: NodeJS.Timeout;
  Form: UntypedFormGroup;
  loadResultsSubscription: Subscription;
  @ViewChild('input') public input!: ElementRef;
  formId: number;
  // TODO
  loadedServiceType = 'telegram';
  private destroy$: Subject<void> = new Subject();
  public loadContacts$: ReplaySubject<string> = new ReplaySubject();
  public loadContactsVisible$: ReplaySubject<boolean> = new ReplaySubject();

  public loadContactsForce$: ReplaySubject<string> = new ReplaySubject();

  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    public allMessengersService: AllMessengersService,
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    public allService: AllService,
    public appService: AppService
  ) {
    this.cd.detach();
    const min = Math.ceil(1111);
    const max = Math.floor(9999);
    this.formId = Math.floor(Math.random() * (max - min + 1)) + min;
  }

  ngOnInit(): void {
    this.cd.detectChanges();
    // TODO this.loadedServiceType = this.allMessengersService.Service.type;
    this.dcService.detectChanges$.pipe(filter(v => v === 'contacts-list')).subscribe((component) => {
      this.cd.detectChanges();
    });
    this.allService.wsService.on<IMessage>('online').pipe(takeUntil(this.destroy$)).subscribe((data) => {
      from(this.arResult)
        .pipe(filter((v: any) => v.id === data.user_id && this.Service.type === data.path))
        .subscribe((chat: any) => {
          chat.online = data?.online;
          if (!chat.online) {
            chat.typing = false;
          }
          chat.last_seen = data?.last_seen;
        });
      this.cd.detectChanges();
    });
    this.dcService.detectChanges$.pipe(
      filter(v => v === 'contacts-list'),
      takeUntil(this.destroy$)
    ).subscribe((component) => {
      this.cd.detectChanges();
    });
    this.zone.runOutsideAngular(() => {
      fromEvent(this.scroll, 'scroll')
        .pipe(
          takeUntil(this.destroy$),
          // debounceTime(5),
          // Is elementId scrolled for more than 50 from top?
          filter((e: Event) => (e.srcElement as Element).scrollHeight - (e.srcElement as Element)?.scrollTop < 1500)
          // takeUntil(this.destroy$),
        )
        .subscribe((v) => {
          this.lazyLoad(true);
        });
    });
    this.loadContactsVisible$.pipe(filter((v) => !!v), takeUntil(this.destroy$), first())
      .subscribe((intiator) => {
      this.loadContacts(true, 0, 'loadContactsVisible$ - ' + intiator);
    });
    this.loadContacts$.pipe(takeUntil(this.destroy$), throttleTime(3000))
      .subscribe((intiator) => {
      this.loadContacts(true, 0, 'loadContacts$ - ' + intiator);
    });
    this.loadContactsForce$.pipe(takeUntil(this.destroy$))
      .subscribe((intiator) => {
      this.loadContacts(true, 0, 'loadContactsForce$ - ' + intiator);
    });
  }

  searchFocus() {
    if (!isMobile()) {
      try {
        this.input.nativeElement.focus();
      } catch (e) {
      }
    }
  }

  searchContacts(val: string) {
    this.q = val.toLowerCase();
    if (this.search === 'query') {
      this.arResult = [];
      this.isLoaded = false;
      this.loadContacts$.next('searchContacts');
    } else {
      if (this.arResultBuffer?.length === 0) {
        this.arResultBuffer = this.arResult;
      }
      this.arResult = this.arResultBuffer.filter(
        (v) =>
          v?.name?.first?.toLowerCase().indexOf(this.q) > -1 ||
          v?.name?.last?.toLowerCase().indexOf(this.q) > -1 ||
          v?.username?.toLowerCase().indexOf(this.q) > -1 ||
          v?.phone_number?.indexOf(this.q) > -1 ||
          v?.title?.toLowerCase().indexOf(this.q) > -1
      );
    }
    this.cd.detectChanges();
  }

  addTitleList(arContacts: any) {
    if (this.sort === 'abc') {
      if (isObject(arContacts)) {
        for (let i = 0; i < arContacts.length; i++) {
          arContacts[i].first_character = (arContacts[i]?.name?.first || arContacts[i]?.name?.last)
            .substring(0, 1)
            .toLowerCase();
          arContacts[i].show_title =
            i === 0 || (arContacts[i - 1] && arContacts[i - 1].first_character !== arContacts[i].first_character);
        }
      }
    }
  }

  loadContacts(vizible: boolean, timeout = 0, initiator = '') {
    log('loadContacts: ' + initiator);
    if (isMobile() && timeout === 0) {
      timeout = 500;
    }
    if (!vizible || (this.arResult?.length > 0) && this.loadedServiceType === this.Service.type) {
      return;
    }
    if (this.Service.type !== 'all') {
      this.loadedServiceType = this.Service.type;
    }
    this.isLoadError = false;
    clearTimeout(this.getAvalibleTimeout);
    this.getAvalibleTimeout = setTimeout(() => {
      /// Local data
      if (this.source === 'chats') {
        let chatsLocal: MessageUser[] | Chat[] = this.allService.arChat.filter((v) => v.service_type === this.Service.type && v.type !== 'channel');
        log('chatsLocal', this.Service.type);
        if (chatsLocal?.length > 0) {
          chatsLocal = this.arSort(chatsLocal);
          this.arResult = chatsLocal;
          this.isLoaded = this.showSearch = true;
          this.searchFocus();
          timeout = 15000;
          this.cd.detectChanges();
        }
      }
      const source$ = this.source === 'chats' ? this.Service.chatList() : this.Service.contactsList(this.q);
      this.loadResultsSubscription && this.loadResultsSubscription.unsubscribe();
      this.loadResultsSubscription = source$.pipe(takeUntil(this.destroy$)).subscribe(
        (result: any) => {
          if (isUndefined(result.error_msg)) {
            result.results = this.arSort(result.results);
            this.addTitleList(result.results);
            if (this.Service.type !== 'all') {
              result.results.map((v) => (v.service_type = this.Service.type));
            }
            this.arResult = result.results;
            this.isLoaded = this.showSearch = true;
            this.searchFocus();
            this.cd.detectChanges();
          } else {
            alert(result.error_msg);
          }
          this.cd.detectChanges();
        },
        (error) => {
          this.isLoadError = error;
          this.cd.detectChanges();
        }
      );
    }, timeout);
  }

  arSort(array: MessageUser[] | Chat[]): MessageUser[] | Chat[] {
    if (this.sort === 'abc' || !this.sort) {
      return array.sort((a: any, b: any) => {
        const aValue = a.name?.first?.toLowerCase();
        const bValue = b.name?.first?.toLowerCase();
        if (!bValue) {
          return -1;
        }
        return aValue < bValue ? -1 : bValue < aValue ? 1 : 0;
      });
    } else if (this.sort === 'chats') {
      return this.appService.chatSort(array);
    }
  }

  toggleUser(event, client): void {
    log('toggleUser', client);
    this.onToggleUser.next(client);
    this.cd.detectChanges();
  }

  trackByFn(index, element: any) {
    return element ? element.id : undefined;
  }

  lazyLoad(vizible): void {
    if (vizible) {
      this.showCount += 5;
      this.cd.detectChanges();
    }
  }

  contactsToggleService(Service: IMessengerConnector): void {
    this.q = '';
    this.Service = Service;
    this.loadContactsForce$.next('contactsToggleService');
    this.onToggleService.next(Service);
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    clearTimeout(this.getAvalibleTimeout);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
